import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DataSourceProfileComponent } from './pages/data-source-profile/data-source-profile.component';
import { DataSourceDetailComponent } from './pages/data-source-detail/data-source-detail.component';
import { DataSourcesComponent } from './pages/data-sources/data-sources.component';
import { ProjectCanvasComponent } from './pages/project-canvas/project-canvas.component';
import { OutputsComponent } from './pages/outputs/outputs.component';
import { AnomalyDetectionComponent } from './pages/anomaly-detection/anomaly-detection.component';
import { AiReadinessComponent } from './pages/ai-readiness/ai-readiness.component';
// HYPOTHESIS TESTING - COMMENTED OUT
// import { HypothesisTestingComponent } from './pages/hypothesis-testing/hypothesis-testing.component';
import { ActivityComponent } from './pages/activity/activity.component';
import { LoginComponent } from './pages/login/login.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';
import { MarketplaceLandingComponent } from './pages/marketplace-landing/marketplace-landing.component';
import { RegistrationWizardComponent } from './pages/registration-wizard/registration-wizard.component';
import { AuthGuard, LoginGuard } from './services';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      { 
        path: 'login', 
        component: LoginComponent,
        canActivate: [LoginGuard] // Prevent logged-in users from accessing login page
      },
      {
        path: 'password-reset',
        component: LoginComponent
        // No guard - allow anyone to access password reset with valid code
      },
      { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
      // { path: 'collections', component: CollectionsComponent },
      // { path: 'projects', component: ProjectsComponent },
      { path: 'project-canvas/:id', component: ProjectCanvasComponent, canActivate: [AuthGuard] },
      { path: 'outputs/:id', component: OutputsComponent, canActivate: [AuthGuard] },
      { path: 'outputs', component: OutputsComponent, canActivate: [AuthGuard] },
      // { path: 'run-results', component: ProjectsComponent },
      { path: 'data-sources', component: DataSourcesComponent, canActivate: [AuthGuard] },
      { path: 'activity', component: ActivityComponent, canActivate: [AuthGuard] },
      { path: 'data/profile', component: DataSourceProfileComponent, canActivate: [AuthGuard] },
      { path: 'data/profile/:datasourceId', component: DataSourceProfileComponent, canActivate: [AuthGuard] },
      { path: 'data/profile-view/:datasourceId', component: DataSourceProfileComponent, canActivate: [AuthGuard] }, // Alternate route for viewing existing profiles
      { path: 'data/detail/:datasourceId', redirectTo: 'data/profile/:datasourceId', pathMatch: 'full' }, // Redirect to consolidated profile view
      { path: 'anomaly-detection', component: AnomalyDetectionComponent, canActivate: [AuthGuard] },
      { path: 'anomaly-detection/run/:runId', component: AnomalyDetectionComponent, canActivate: [AuthGuard] },
      { path: 'ai-readiness', component: AiReadinessComponent, canActivate: [AuthGuard] },
      // HYPOTHESIS TESTING - COMMENTED OUT
      // { path: 'hypothesis-testing', component: HypothesisTestingComponent },
      // { path: 'hypothesis-testing/run/:runId', component: HypothesisTestingComponent },
      { path: 'change-password', component: ChangePasswordComponent, canActivate: [AuthGuard] },
      { path: 'user-management', component: UserManagementComponent, canActivate: [AuthGuard] },
      {
        path: 'registration',
        component: RegistrationWizardComponent
        // No guard - public page for new user registration
      },
      {
        path: 'marketplace/landing',
        component: MarketplaceLandingComponent
        // No guard - public page accessible from Azure Marketplace redirect
      }
    ]
  },
  { path: '**', redirectTo: '/login' } // Redirect unknown routes to login
];
